// extracted by mini-css-extract-plugin
export default {"outerDiv":"RecentlyViewed_outerDiv__Vtt+e","innerDiv":"RecentlyViewed_innerDiv__6ke8d"};